import styled from 'styled-components'

export const PageTitle = styled.h1`
font-family: Poppins;
font-weight: 600;
font-size: 26px;
color: #242735;
margin-bottom: 25px;
margin-top: 15px;
`

export default PageTitle
